import { CheckboxCard as ChakraCheckboxCard } from '@chakra-ui/react';
import { Fragment } from 'react';

type CheckboxCardProps = ChakraCheckboxCard.RootProps & {
  icon?: React.ReactElement;
  label?: React.ReactNode;
  description?: React.ReactNode;
  addon?: React.ReactNode;
  indicator?: React.ReactNode | null;
  indicatorPlacement?: 'start' | 'end' | 'inside';
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  ref?: React.RefObject<HTMLInputElement>;
};

export const CheckboxCard = ({
  inputProps,
  label,
  description,
  icon,
  addon,
  indicator = (
    <ChakraCheckboxCard.Indicator
      _checked={{
        bgColor: 'purple.200',
        borderColor: 'purple.200',
        boxShadow: 'sm',
      }}
    />
  ),
  indicatorPlacement = 'end',
  ref,
  ...rest
}: CheckboxCardProps) => {
  const hasContent = label || description || icon;
  const ContentWrapper = indicator ? ChakraCheckboxCard.Content : Fragment;

  return (
    <ChakraCheckboxCard.Root
      {...rest}
      flex={0}
      _checked={{
        borderColor: 'purple.200',
        boxShadowColor: 'purple.200',
      }}
    >
      <ChakraCheckboxCard.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckboxCard.Control>
        {indicatorPlacement === 'start' && indicator}
        {hasContent && (
          <ContentWrapper>
            {icon}
            {label && (
              <ChakraCheckboxCard.Label whiteSpace="nowrap" textStyle="title">
                {label}
              </ChakraCheckboxCard.Label>
            )}
            {description && (
              <ChakraCheckboxCard.Description>{description}</ChakraCheckboxCard.Description>
            )}
            {indicatorPlacement === 'inside' && indicator}
          </ContentWrapper>
        )}
        {indicatorPlacement === 'end' && indicator}
      </ChakraCheckboxCard.Control>
      {addon && <ChakraCheckboxCard.Addon>{addon}</ChakraCheckboxCard.Addon>}
    </ChakraCheckboxCard.Root>
  );
};

export const CheckboxCardIndicator = ChakraCheckboxCard.Indicator;
